import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonUtilFoundationModule } from '@common/util-foundation';
import { SharedUiComponentsCoreModule } from '@domgen/dgx-fe-components-core';
import { SharedUiDynamicFormBuilderModule } from '@domgen/dgx-fe-dynamic-form-builder';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { OrenAppliancePlanDetailComponent } from './appliance-plan-detail/appliance-plan-detail.component';
import { OrenBannerComponent } from './banner/banner.component';
import { CoverDurationSummaryComponent } from './cover-duration-summary/cover-duration-summary.component';
import { OrenCustomerDetailsComponent } from './customer-details/customer-details.component';
import { DontMissOutAreaComponent } from './dont-miss-out-area/dont-miss-out-area.component';
import { GoToMyAccountComponent } from './go-to-my-account/go-to-my-account.component';
import { LandingHeaderComponent } from './landing-header/landing-header.component';
import { MissingEmailAddressComponent } from './missing-email-address/missing-email-address.component';
import { NeedToKnowComponent } from './need-to-know/need-to-know.component';
import { OfferRenewalFormComponent } from './offer-renewal-form/offer-renewal-form.component';
import { QuoteCoverInclusionsComponent } from './quote-cover-inclusions/quote-cover-inclusions.component';
import { OrenSafeHandsComponent } from './safe-hands/safe-hands.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiComponentsCoreModule,
    CommonUtilFoundationModule,
    ReactiveFormsModule,
    SharedUiDynamicFormBuilderModule,
    DgxQmModule,
  ],
  declarations: [
    OrenSafeHandsComponent,
    OfferRenewalFormComponent,
    LandingHeaderComponent,
    DontMissOutAreaComponent,
    MissingEmailAddressComponent,
    CoverDurationSummaryComponent,
    NeedToKnowComponent,
    QuoteCoverInclusionsComponent,
    GoToMyAccountComponent,
    OrenBannerComponent,
    OrenAppliancePlanDetailComponent,
    OrenCustomerDetailsComponent,
  ],
  exports: [
    OrenSafeHandsComponent,
    OfferRenewalFormComponent,
    LandingHeaderComponent,
    DontMissOutAreaComponent,
    MissingEmailAddressComponent,
    CoverDurationSummaryComponent,
    NeedToKnowComponent,
    QuoteCoverInclusionsComponent,
    GoToMyAccountComponent,
    OrenBannerComponent,
    OrenAppliancePlanDetailComponent,
    OrenCustomerDetailsComponent,
  ],
})
export class OrenUiComponentsModule {}
